import { getCmsTrustBuildersAction } from "../../../Actions/LogicActions/Search/GetCmsTrustBuilderAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";

export class TrustBuilderStep extends StepFlow {
  get stepName() { return "TrustBuilderStep"; }

  async onEventSetup(): Promise<void> {
    // Disabled — TrustBuilder widget removed; suppress the /trust-builders fetch.
    // this.registerEventSubscription(
    //   _eventBus.on({
    //     eventName: evtTree.trustBuilder.Get,
    //     handler: async () => {
    //       getCmsTrustBuildersAction.execute();
    //     }
    //   })
    // );
  }

  async onExecute(): Promise<void> {
    // Disabled — TrustBuilder widget removed; do not emit the fetch event.
    // this.eventBus.emit({
    //   eventName: evtTree.trustBuilder.Get,
    // });
  }
}
export const trustBuilderStepDeclaration = new StepDefinition({
  stepName: "TrustBuilderStep",
  stepClass: TrustBuilderStep
});
